import { useMemo } from "react";
import { Item } from "types";

export const useFilterProducts = (items: Item[], searchText: string) => {
  return useMemo(
    () =>
      items
        .filter(
          (item) =>
            item?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
            item?.importcode?.toLowerCase().includes(searchText.toLowerCase())
        )
        .sort((a, b) => (a.position > b.position ? 1 : -1)),
    [items, searchText]
  );
};
